<template>
  <section class="main">
    <loader v-if="!loaded" />
    <aside v-if="loaded" class="sidebar">
      <div class="sidebar__my">
        <div class="header">
          <template v-if="isDeviceLinked">
            <span class="header__active">{{ this.$t("ACTIVE_DEVICE") }}</span>
            <img class="header__img" :src="currentDevice.icon" />
            <div class="header__desc">
              <span class="header__title">{{ currentDevice.model }} <span v-if="currentDevice.name">{{
                currentDevice.name }}</span></span>
              <span class="header__device">{{ currentDevice.ios }}</span>
              <ul class="header__list">
                <template v-if="currentDevice.plus">
                  <li class="header__divider"></li>
                  <li class="header__status header__status_pro">Plus</li>
                </template>
                <template v-if="currentDevice.premium">
                  <li class="header__divider"></li>
                  <li class="header__status header__status_premium">PREMIUM</li>
                </template>
              </ul>
            </div>
          </template>

          <template v-else>
            <img class="header__img" src="@/assets/icon-nodevice.svg" />
            <div class="header__desc">
              <span class="header__error-status g-status g-status_error">{{
                $t("NO_DEVICE_LINKED")
              }}</span>
              <router-link to="/link" class="g-button">{{
                $t("LINK_YOUR_DEVICE")
              }}</router-link>
            </div>
          </template>
        </div>
        <nav>
          <ul class="nav">
            <li
              class="nav__item"
              :class="{ nav__item_disabled: !isDeviceLinked && !item.alwaysClickableWithoutDevice }"
              v-for="item in menuItems"
              :key="item.title"
            >
              <a v-if="item.external" class="nav__link" :href="item.link" :target="item.target">
                {{ item.title }}
              </a>
              <router-link v-else class="nav__link" :to="item.link">{{
                item.title
              }}</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
    <slot v-if="loaded">
      <router-view />
    </slot>
  </section>
</template>

<script>
import Loader from '@/components/Loader';
import getMainMenuItems from '@/utils/MainMenu';

export default {
  components: { Loader },
  data() {
    return {
      menuItems: [],
    };
  },
  computed: {
    loaded() {
      const { configLoaded, devicesLoaded } = this.$store.getters;
      return configLoaded && devicesLoaded;
    },
    isDeviceLinked() {
      return this.$store.getters.isDeviceLinked;
    },
    currentDevice() {
      return this.$store.getters.devices
        .find(device => device.lt === this.$store.getters.lt) || {};
    },
  },
  created() {
    this.menuItems = getMainMenuItems();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: flex;
}

.main::v-deep .intro {
  background: var(--my-heading-bg);
  border-radius: 2px;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 15px;
  display: block;
  margin-bottom: 25px;

  @include notebook {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    padding: 7px 10px;
    margin-bottom: 15px;
  }
}

.sidebar {
  flex: 0 0 400px;
  margin-right: 30px;

  @include notebook {
    display: none;
  }

  &__my {
    background: var(--bg);
    border: 1px solid var(--tertiary-accent);
    box-shadow: 0 4px 10px 0 var(--shadow-color-1);
    border-radius: 8px;
    overflow: hidden;
  }
}

.header {
  padding: 20px 25px;
  display: flex;
  align-items: center;
  position: relative;

  &__error-status {
    font-size: 14px;
    margin-bottom: 10px;
  }

  &__title {
    color: var(--text-primary);
    font-weight: 500;
    display: block;
    margin-bottom: 10px;
  }

  &__active {
    background: var(--tertiary-accent);
    border-radius: 2px;
    padding: 4px;
    color: var(--text-tertiary-accent);
    font-size: 10px;
    position: absolute;
    right: 0;
    top: 0;
  }

  &__img {
    height: 90px;
    margin-right: 15px;
    filter: var(--img-filter);
  }

  &__list {
    display: flex;
    margin-top: 8px;
  }

  &__status {
    border-radius: 2.5px;
    display: flex;
    align-items: center;
    padding: 3px;

    &_jail {
      font-size: 12px;
      background: var(--tertiary-accent);
      color: var(--text-tertiary-accent);

      &-active {
        color: #053305;
        background: var(--bg-success);
      }
    }

    &_pro {
      text-transform: uppercase;
      background: $primary;
      font-size: 11px;
      font-weight: 700;
      color: #fff;
      padding-bottom: 2px;
    }

    &_premium {
      background: $primary;
      font-size: 11px;
      font-weight: 700;
      color: #fff;
      padding-bottom: 2px;
    }
  }

  &__divider {
    background: #d8d8d8;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    margin: auto 5px;
  }
}

.nav__link,
.links__link {
  display: block;
  padding: 10px 15px;
  color: var(--text-primary);
}

.nav__item_disabled {
  opacity: 0.5;
  pointer-events: none;
}

.nav {
  &__link {
    border-top: 1px solid var(--tertiary-accent);

    &.router-link-active {
      background-image: var(--pink-gradient);
    }
  }
}

.links {
  &__link {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>
